import {useDebugValue} from 'react';

import {useHotkeys, useHover, useFocus} from 'polyphony/hooks/dom';
import {combineRefs} from 'polyphony/util';

export const useA11y = (role, attrs = {}, isTabbable = true) => {
    const [focus, focusRef] = useFocus();
    const domRef = r => {
        if (r) {
            const ti = r.getAttribute('tabindex');
            const _role = r.getAttribute('role');
            r.classList.add('polyphony-a11y');
            r.setAttribute('focusable', 'true');
            r.setAttribute('tabindex', isTabbable ? ti ? ti : '0' : '-1');
            if (!_role) r.setAttribute('role', role);
            for (const [a, v] of Object.entries(attrs)) {
                if (!r.getAttribute(a)) {
                    r.setAttribute(a, v);
                }
            }
        }
    };
    return [{focus}, combineRefs([focusRef, domRef])];
};

// foo

/*
    useA11yButton(attrs, isTabbable)

    Returns a ref (see below) that makes a button accessibility-aware.
*/

export const useA11yButton = (attrs = {}, isTabbable = true) => {
    const [{hover, active}, hoverRef] = useHover();
    const [{focus}, aref] = useA11y('button', {
        'aria-pressed': active ? 'true' : 'false',
        ...attrs
    }, isTabbable);

    const hkref = useHotkeys({
        Space: e => e.target.click(),
        Enter: e => e.target.click()
    });

    useDebugValue(`${hover ? 'hover' : 'not hover'} ${active ? 'active' : 'not active'} ${focus ? 'focus' : 'not focused'}`);

    return [{hover, active, focus}, combineRefs([aref, hkref, hoverRef])];
};

